module.exports = __webpack_public_path__ + "store/img/docupet_logo.0a6884c8.png";